import * as esri from "esri-leaflet";

export default class MapConfig {
  basemap: esri.Basemaps;
  zoom: number;
  center: [number, number];
  fitToMarkers: boolean;
  showAddressFinder: boolean;
  hideControls:boolean;
  staticMap: boolean;
  basemapKey: string;

  constructor(
    options: {
      basemap?: esri.Basemaps;
      zoom?: number;
      center?: [number, number];
      fitToMarkers?: boolean;
      showAddressFinder?: boolean;
      hideControls?: boolean;
      staticMap?: boolean;
      basemapKey?: string;
    } = {}
  ) {
    this.basemap = options.basemap || "Topographic";
    this.zoom = options.zoom || 11;
    this.center = options.center || [43.6, -116.25];
    this.fitToMarkers = options.fitToMarkers || false;
    this.showAddressFinder = options.showAddressFinder || false;
    this.hideControls = options.hideControls || false;
    this.staticMap = options.staticMap || false;
    this.basemapKey = options.basemapKey || "AAPK720f6b32317a4e2ca27beb299c58a066V2gg23JaipOw541Bz9ofQeaQkhgRKdLeJk-uYKWBZx9ZPxLAqndZ7UerYfVAUgkB";
  }
}
